import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@t90/ui';

export function ReportsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Reports</h1>
        <p className="text-muted-foreground">
          Generate and view operational reports
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card className="cursor-pointer hover:bg-muted/50 transition-colors">
          <CardHeader>
            <CardTitle>Production Report</CardTitle>
            <CardDescription>
              Daily/weekly/monthly production summaries
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="cursor-pointer hover:bg-muted/50 transition-colors">
          <CardHeader>
            <CardTitle>Trainee Progress</CardTitle>
            <CardDescription>
              Individual and cohort progress reports
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="cursor-pointer hover:bg-muted/50 transition-colors">
          <CardHeader>
            <CardTitle>Quality Metrics</CardTitle>
            <CardDescription>
              Quality control and defect analysis
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="cursor-pointer hover:bg-muted/50 transition-colors">
          <CardHeader>
            <CardTitle>Order Status</CardTitle>
            <CardDescription>
              Order pipeline and fulfillment tracking
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="cursor-pointer hover:bg-muted/50 transition-colors">
          <CardHeader>
            <CardTitle>Financial Summary</CardTitle>
            <CardDescription>
              Revenue and billing overview
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="cursor-pointer hover:bg-muted/50 transition-colors">
          <CardHeader>
            <CardTitle>Location Comparison</CardTitle>
            <CardDescription>
              Cross-location performance metrics
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    </div>
  );
}
